import { render, staticRenderFns } from "./ExcerptEditor.vue?vue&type=template&id=ffca070c&scoped=true&"
import script from "./ExcerptEditor.vue?vue&type=script&lang=js&"
export * from "./ExcerptEditor.vue?vue&type=script&lang=js&"
import style0 from "./ExcerptEditor.vue?vue&type=style&index=0&id=ffca070c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffca070c",
  null
  
)

export default component.exports